import React, {useState} from 'react';
import {Redirect} from 'react-router-dom'//yarn add @types/react-router-dom
import useStyles from './Styles';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';
//import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropDownCircleIcon from '@mui/icons-material/ArrowDropDownCircle';
import {Inc,Owner,SaleSearchCondition} from './Inc';
import {Tools} from './Tools';
import StoreImg from './StoreImg';
import Ajax from './Ajax';
import Loading from './Loading';
import SaleListSearch from './SaleListSearch';
import Title from './Title';
import AppBank from './AppBank';
import MultiLines from './MultiLines';

interface SaleListProps {
	owner:Owner,
	bank:AppBank,
}
//let p:number = 1;

const SaleList = (props:SaleListProps)=> {
    Ajax.setEditorId( props.owner.owner_id );
    const classes = useStyles();
    const [states,setStates] = useState({
        sales:[],
        isLoading:true,
		currentPage:1,
        pager:null,
        cond:Inc.defaultSaleSearchCondition(),
    });
    const search = (cond:SaleSearchCondition,page:number)=>{
        //console.log("search",cond);
        setStates({...states,"isLoading":true});
        // if( first ){
        //     p = 1;
        // }
        window.scrollTo(0,0);
        Ajax.search("sale/list",cond,page,(res:any)=>{
            //console.log(res.sales);
            if( res.ok ){
                setStates({sales:res.sales,cond:cond,currentPage:page,pager:res.pager,isLoading:false});
            } else {
                setStates({...states,"isLoading":false});
            }
        });
    }
	const jump = (newPage:number)=>{
		//send(values,p);
		//p = newPage;
		search(states.cond,newPage);
	}
	const PutRow = (p: {sale: any})=>{
		const sale = p.sale;
		const [open, setOpen] = useState(false);
		const toggle = ()=>{
			setOpen(!open);
		}
		const received = (sale:any,horizontal:boolean,memo:boolean) =>{
			let br = <br/>
			if( horizontal ){
				br = <span>　</span>;
			}
			if( sale.received_date==="" ){
				return (
				<React.Fragment>
					{sale.pay_id==="1" ? (
						<span className="cl cl-aqua">{sale.pay}</span>
					):(
						<span className="cl cl-orange">{sale.pay}</span>
					)}
					{br}
					<span className="cl cl-gray">未入金</span><br/>
					{memo && sale.delivery_memo && sale.delivery_memo!=="" && <Box style={{backgroundColor:'#FFF5F5',marginTop:'0.5em',padding:'0.5em',fontSize:'90%'}}>
						<MultiLines text={sale.delivery_memo}/>
					</Box>}
				</React.Fragment>
				);
			} else {
				return (
				<React.Fragment>
					<span className="cl cl-green">入金済</span>{br}
					<span>({sale.received_date})</span>{br}
				</React.Fragment>
				);
			}
		}
		const delivery = (sale:any,horizontal:boolean) =>{
			let br = <br/>
			if( horizontal ){
				br = <span>　</span>;
			}
			if(Number(sale.order_type_id)===2){
				return (
				<React.Fragment>
					<span className="badge badgeStore2">倉庫</span>
				</React.Fragment>
				);
			} else if(sale.delivery_date===""){
				return (
				<React.Fragment>
					<span className="cl cl-gray">未定</span>{br}
					{br}
				</React.Fragment>
				);
			} else {
				return (
				<React.Fragment>
					{sale.delivery ? (
						<span className="cl cl-green">発送済</span>
					):(
						<span className="cl cl-aqua">準備中</span>
					)}
					{br}
					<span>({sale.delivery_date})</span>{br}
				</React.Fragment>
				);
			}
		}

		let status_class = "";
		if( sale.dunning ){
			status_class = "cl cl-red";
		} else if( sale.order_status==="2" ){
			status_class = "cl cl-green";
		} else if( sale.order_status==="9" ){
			status_class = "cl cl-gray";
		} else {
			status_class = "cl cl-aqua";
		}

		let su = sale.su;
		if( sale.order_status==="9" && sale.original_su>0 ){
			su = sale.original_su;
		}

		return (
			<>
			<TableRow>
				<TableCell className={classes.tableCellNowrap} style={{verticalAlign:"middle",width:'6em'}} align='center'>
					{sale.order_date}<br/>
					{sale.order_time}<br/>
				</TableCell>
				<TableCell className={classes.tableCellDense} align="center" sx={{width:'80px',display:{lg:'table-cell',md:'none',sm:'table-cell',xs:'none'}}}><StoreImg owner_id={props.owner.owner_id} img_id={sale.img_id} thumb={true} className="imgList"/></TableCell>
				<TableCell className={classes.tableCellDense}>
					<span className={classes.itemId}>ID:{sale.item_id}</span><br/>
					{sale.item_name}<br/>
				</TableCell>
				<TableCell className={classes.tableCellNowrap} style={{textAlign:"right"}} sx={{display:{lg:'table-cell',md:'none',sm:'table-cell',xs:'table-cell'}}}>{sale.price}円</TableCell>
				<TableCell className={classes.tableCellNowrap} style={{textAlign:"right"}} sx={{display:{xs:'none',sm:'table-cell'}}}>{su}</TableCell>
				<TableCell className={classes.tableCellNowrap} style={{textAlign:"center"}} sx={{display:{xs:'none',sm:'none',md:'table-cell'}}}>
					{received(sale,false,false)}
				</TableCell>
				<TableCell className={classes.tableCellNowrap} style={{textAlign:"center"}} sx={{display:{xs:'none',sm:'none',md:'table-cell'}}}>
					{delivery(sale,false)}
				</TableCell>
				<TableCell className={classes.tableCellNowrap} style={{textAlign:"center"}} sx={{display:{xs:'none',sm:'table-cell'}}}>
					<p className={status_class}>
						{sale.order_status_label==="抽選待ち" &&
							<span style={{margin:"0",padding:"0",fontSize:"75%",lineHeight:"1em"}}>同梱商品の<br/></span>
						}
						{sale.order_status_label}
					</p>
				</TableCell>
				<TableCell className={classes.tableCellNowrap} style={{textAlign:"center",width:'2em'}}>
					{!sale.reduced ? (
					<IconButton onClick={toggle} style={{margin:'0',padding:'0'}}><ArrowDropDownIcon/></IconButton>
					):(
					<IconButton onClick={toggle} style={{margin:'0',padding:'0'}}><ArrowDropDownCircleIcon style={{color:'#990000'}}/></IconButton>
					)}
				</TableCell>
			</TableRow>
			{open &&
			<TableRow>
				<TableCell style={{ paddingBottom: '1em', paddingTop: 0, paddingLeft: 0, paddingRight: 0}} colSpan={9}>
					<Table>
						<TableBody>
						<TableRow>
							<TableCell style={{backgroundColor:'#F5F5F5'}} sx={{width:{xs:'30%',sm:'25%'}}}>
								価格
							</TableCell>
							<TableCell>
								{sale.price}円
							</TableCell>
						</TableRow>
						<TableRow>
						<TableCell style={{backgroundColor:'#F5F5F5'}} sx={{width:{xs:'30%',sm:'25%'}}}>
								個数
							</TableCell>
							<TableCell>
								{sale.su}{sale.unit}
							</TableCell>
						</TableRow>
						<TableRow>
							<TableCell style={{backgroundColor:'#F5F5F5'}} sx={{width:{xs:'30%',sm:'25%'}}}>
								小計
							</TableCell>
							<TableCell>
								{sale.shokei}円
							</TableCell>
						</TableRow>
						<TableRow>
							<TableCell style={{backgroundColor:'#F5F5F5'}} sx={{width:{xs:'30%',sm:'25%'}}}>
								手数料
							</TableCell>
							<TableCell>
								{sale.cost}円
							</TableCell>
						</TableRow>
						<TableRow>
							<TableCell style={{backgroundColor:'#F5F5F5'}} sx={{width:{xs:'30%',sm:'25%'}}}>
								差引
							</TableCell>
							<TableCell>
								{sale.sashi}円
							</TableCell>
						</TableRow>
						<TableRow>
							<TableCell style={{backgroundColor:'#F5F5F5'}} sx={{width:{xs:'30%',sm:'25%'}}}>
								支払期限
							</TableCell>
							<TableCell>
								{sale.limit_date}<span style={{fontSize:'85%',color:'#333333',marginLeft:'1em'}}>※支払期限を過ぎても入金が確認できない場合、翌日中にキャンセル処理が行われます（代金引換は除く）</span>
							</TableCell>
						</TableRow>
						<TableRow>
							<TableCell style={{backgroundColor:'#F5F5F5'}} sx={{width:{xs:'30%',sm:'25%'}}}>
								入金
							</TableCell>
							<TableCell>
								{received(sale,true,true)}
							</TableCell>
						</TableRow>
						<TableRow>
							<TableCell style={{backgroundColor:'#F5F5F5'}} sx={{width:{xs:'30%',sm:'25%'}}}>
								発送
							</TableCell>
							<TableCell>
								{delivery(sale,true)}
							</TableCell>
						</TableRow>
						<TableRow>
							<TableCell style={{backgroundColor:'#F5F5F5'}} sx={{width:{xs:'30%',sm:'25%'}}}>
								状態
							</TableCell>
							<TableCell>
								<p className={status_class} style={{display:'inline'}}>
									{sale.order_status_label==="抽選待ち" &&
									<span style={{margin:"0",padding:"0",fontSize:"75%",lineHeight:"1em"}}>同梱商品の<br/></span>
									}
									{sale.order_status_label}
								</p>
							</TableCell>
						</TableRow>

						{sale.reduced!=='' ? (
						<TableRow>
							<TableCell style={{color:'#990000',whiteSpace:'nowrap',backgroundColor:'#F5F5F5'}}>
								変更記録
							</TableCell>
							{sale.order_status==='9' ?
							(
							<TableCell>
								{sale.reduced} にキャンセルされました
							</TableCell>
							):(
							<TableCell>
								{sale.reduced} に個数が変更されました<span style={{fontSize:'90%',color:'#333333'}}>（受注時の個数は {sale.original_su+sale.unit} ）</span>
							</TableCell>
							)}
						</TableRow>
						):(
						<TableRow>
							<TableCell style={{backgroundColor:'#F5F5F5'}}>
								変更記録
							</TableCell>
							<TableCell>
								なし
							</TableCell>
						</TableRow>
						)}
						</TableBody>
					</Table>
				</TableCell>
			</TableRow>
			}
			</>
		);

	}

	if( props.owner.owner_id===0 ){
		return <Redirect to="/profile"/>
	}

	return (
		<div id="sale_list" className={classes.root}>
            <Grid container spacing={2}>
                <Grid item xs={12} md={8} lg={9}>
                    <Paper className={classes.paper}>
                        <Title text="売上履歴" icon="trending"/>
                        <div style={{marginBottom:"2em"}}>
                        ここにあなたの商品の売上がリアルタイムで表示されます。<br/>
                        入金と発送の両方が済めば<span className="cl cl-green">完了</span>となります。お客様（購入者）のご都合により入金や発送が遅れたり、ご注文が<span className="cl cl-gray">キャンセル</span>となる場合もありますのであらかじめご了承ください。 <br/>
                        </div>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell className={classes.tableHeadNowrap} align="center">受注日時</TableCell>
                                    <TableCell className={classes.tableHeadNowrap} align="center" sx={{display:{lg:'table-cell',md:'none',sm:'table-cell',xs:'none'}}}>画像</TableCell>
                                    <TableCell className={classes.tableHeadNowrap} align="center">商品名</TableCell>
									<TableCell className={classes.tableHeadNowrap} align="center" sx={{display:{lg:'table-cell',md:'none',sm:'table-cell',xs:'table-cell'}}}>価格</TableCell>
									<TableCell className={classes.tableHeadNowrap} align="center" sx={{display:{xs:'none',sm:'table-cell'}}}>個数</TableCell>
									<TableCell className={classes.tableHeadNowrap} align="center" sx={{display:{xs:'none',sm:'none',md:'table-cell'}}}>入金</TableCell>
									<TableCell className={classes.tableHeadNowrap} align="center" sx={{display:{xs:'none',sm:'none',md:'table-cell'}}}>発送</TableCell>
                                   	<TableCell className={classes.tableHeadNowrap} align="center" sx={{display:{xs:'none',sm:'table-cell'}}}>状態</TableCell>
									<TableCell className={classes.tableHeadNowrap}> </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                        {states.sales.map( (sale:any,index:number)=>{
                            const key = "sale"+index;
							return <PutRow key={key} sale={sale}/>
                        })}
                            </TableBody>
                        </Table>
						<div style={{padding:"1em"}}>
						{Tools.pager(states.pager,jump)}
						</div>
                    </Paper>
                </Grid>
                <Grid item xs={12} md={4} lg={3}>
                    <Paper className={classes.paper}>
                        <SaleListSearch update={search} bank={props.bank} bankKey={"savedSaleListItemSearchCondition"}/>
                    </Paper>
                </Grid>
            </Grid>

            <Loading isLoading={states.isLoading}/>
		</div>
	);
}

export default SaleList;
